export function isObject(value) {
    var type = typeof value;
    return value !== null && (type === 'object' || type === 'function');
}
export function omit(source) {
    var fields = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        fields[_i - 1] = arguments[_i];
    }
    var result = {};
    if (isObject(source)) {
        result = Object.assign(result, source);
        fields.forEach(function (field) { return delete result[field]; });
    }
    return result;
}
//# sourceMappingURL=helpers.js.map


//////////////////
// WEBPACK FOOTER
// ./~/apollo-client-rxjs/utils/helpers.js
// module id = 189
// module chunks = 4